export enum RequestError {
    FetchError = 'Request to resource/collection failed',
    ResponseJsonError = 'Unable to retrieve json() from fetch response',
    ResponseNotArrayError = 'Object returned by API expected to be an array but is not',
    NoHttpSuccessCodeError = 'Http call did not receive a success response',
    NoValidItemsError = 'Object returned by API has no items of the expected format',
    ResponseNotExpectedFormat = 'Object returned by API was not of the expected type',
}
